// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".login-side .locked-user .login-titles .sub-title{padding:5vh 0}\n", "",{"version":3,"sources":["webpack://./src/components/pages/LockedUser.scss"],"names":[],"mappings":"AAEA,kDAEI,aAAc","sourcesContent":["@import '@/styles/colors.scss';\n\n.login-side .locked-user {\n  .login-titles .sub-title {\n    padding: 5vh 0;\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
